import { Component, OnInit ,Input, Output, EventEmitter,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment'; 
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { CustomServiceService } from '../../service/custom-service.service';
@Component({
  selector: 'app-whats-new-details',
  templateUrl: './whats-new-details.component.html',
  styleUrls: ['./whats-new-details.component.css']
}) 
export class WhatsNewDetailsComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,public encDec:EncryptDecryptService,private route: Router,private httpservice: CustomServiceService) { }
  language:any =sessionStorage.getItem('locale');//dynamic
  content_apiresponse:any;
  mediaResponse :any;
  whatsnewDetails:any;
  pageAlias:any="";
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:any;
  Ltype:any;
  archType:boolean=false;
  backend_url: any = environment.serviceURL;
  plugin_menu_dtl:any;
  employee_con:any="";
 
  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  ngOnInit(): void {
 
    this.start=(this.currentPage - 1)*this.limit;
   this. getwhatsNewDetails(this.start,this.limit,this.currentPage,'');
   if(this.employee_con==null){
    this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
    this.getPluginPageDetials(this.plugin_menu_dtl);
  } else {
    this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
  }
  }
  arcType:any;
  getwhatsNewDetails(start:number,limit:number,currentPage:number,type:any){
    let params = {
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": '',
      "viewParameters": type,
      "ZONE_ID": environment.ZONE_ID, 
      "bitDeletedFlag": 0,
       "tinPublishStatus": 1,
       "typeCheck": this.archType,
       "mytime":this.datetime.date
    };
   this.fciwebservice.getWhatsNewDetails(params).subscribe((response: HttpEvent<any>) => {
     switch (response.type) {
       case HttpEventType.Sent:
         //console.log('Sent' + HttpEventType.Sent);
         break;
       case HttpEventType.ResponseHeader:
         //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
         break;
       case HttpEventType.UploadProgress:
         //this.evenTotal = response.total;
         //this.progress = Math.round(response.loaded / this.evenTotal * 100);
         break;
       case HttpEventType.Response:
         this.content_apiresponse = response.body;
         let respData = this.content_apiresponse.RESPONSE_DATA;
         let respToken = this.content_apiresponse.RESPONSE_TOKEN;
         let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
         if (respToken == verifyToken) {
           let response: any = Buffer.from(respData, 'base64');
           response = JSON.parse(response);
           this.whatsnewDetails = response.result;
           this.arcType = type;
           if(response.result.length > 0){
            this.totalRecords = this.whatsnewDetails[0].count; 
                     
          } else {
            this.totalRecords = 0;
          }
        
         }
     }
   });
  }
  getSelectTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectTitle;
  }
  pageChanged(page: any) {
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getwhatsNewDetails(this.start,this.limit,this.currentPage,'');
  }
  archiveDetails(){ 
    this.archType = true;
    this.getwhatsNewDetails(this.start,this.limit,this.currentPage,true);
  }
  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }
  
  CheckChild(event:any){
    return event;
  }
  viewDetails(id: any, pageName: any){
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['./'+ pageName +'/', encSchemeStr]);
  }

  
  checkFileExists(obj:any):boolean{
 // alert(obj.NewDoc);
 
    if(obj.NewDoc!=""){
      return true;
    }
  //  if(obj.uploadDocument_details.fileSize==""){
  //   return false;
  //  }
  return false;
  }
  goToExtLink(url: any) {
    Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }

  showBarComponent:boolean=false;
  emp_apires:any;
  showEmpMen:boolean=false;
  p_apirespons: any;
  P_data: any;
  navMenu:boolean=false;
  navmenuloadCss = "background-color: #167a44; height: 100%;";
  showNavComponent:boolean=false;


  emp_dtl:any={'title':''};
  getEmployeeCornerDtl(id:any){
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [ 
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.emp_apires = response.body;
        let respData = this.emp_apires.RESPONSE_DATA;
        let respToken = this.emp_apires.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.result.sec_1.length > 0){
            this.emp_dtl=response_.result.sec_1[0];
            this.showBarComponent=true;
            this.showEmpMen = true;
          }
        } 
      }
    });
  }

  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }
 

  getPluginPageDetials(details:any) {
    let params;
    if(details!==null){
      let d = JSON.parse(details);
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link':d.selectPlugin,
        'localdata':true,
      };
    } else{
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link':this.CurrentRouteFn(),
        'localdata':false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.original.status){
            this.P_data = response_.original;
            this.navMenu = response_.original.hasMenu;
            this.navmenuloadCss = "height: 100%;";
          } else {
            this.P_data = response_.original;//somthing wrong
          }
          this.showNavComponent=true;
          this.showBarComponent=true;
        } 
      }
    });
  }

  goToPage(link: any) {
    this.archType=false
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate([link]));
  }

}
